import { render, staticRenderFns } from "./onboardingPage.vue?vue&type=template&id=2f236994&scoped=true"
import script from "./onboardingPage.vue?vue&type=script&lang=js"
export * from "./onboardingPage.vue?vue&type=script&lang=js"
import style0 from "./onboardingPage.vue?vue&type=style&index=0&id=2f236994&prod&scoped=true&lang=css"
import style1 from "./onboardingPage.vue?vue&type=style&index=1&id=2f236994&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f236994",
  null
  
)

export default component.exports